export default __webpack_public_path__ + "static/media/inefop_services.a0c91575.png";